<template>
  <SheetModal
    size="Hug"
    theme="White"
    :canClose="false"
    @close="emit('close')"
  >
    <div class="DeleteAccountModalView__layout">
      <header class="DeleteAccountModalView__header">
        <Icon
          size="20px"
          :name="IconName.ExclamationDiamond"
        />

        <UIText
          tag="h2"
          size="Medium"
          weight="Medium"
        >
          Delete account
        </UIText>
      </header>

      <section class="DeleteAccountModalView__content">
        <UIText
          tag="h2"
          size="2XLarge"
          weight="Medium"
        >
          Sorry to see you go
        </UIText>

        <UIText tag="p">
          We’re sorry to see you go! Deleting your account means you’ll permanently lose access to all your financial data and insights. If you’re sure about this decision, please confirm to proceed.
        </UIText>

        <FormButton
          class="DeleteAccountModalView__confirmButton"
          isRounded
          @click="handleConfirmClick"
        >
          Permanently delete my account
        </FormButton>

        <UIText
          class="DeleteAccountModalView__backButton"
          tag="button"
          size="Small"
          weight="Medium"
          @click="emit('close')"
        >
          Go back
        </UIText>
      </section>
    </div>
  </SheetModal>
</template>

<script lang="ts" setup>
import SheetModal from "@cosine/components/SheetModal.vue";

import UIText from "@cosine/components/UIText.vue";
import useAuthStore from "@cosine/stores/useAuthStore";
import FormButton from "@cosine/components/FormButton.vue";
import Icon from "@cosine/components/Icon.vue";
import { IconName } from "@cosine/components/Icon.types";

const emit = defineEmits<{
  close: [],
}>();

const {
  suspendAccount,
} = useAuthStore();

function handleConfirmClick () {
  suspendAccount();
}
</script>

<style lang="scss" scoped>
.DeleteAccountModalView__layout {
  display: flex;
  flex-direction: column;
  gap: 16px;

  color: var(--colorSwissBlack);
}

.DeleteAccountModalView__header {
  display: flex;
  gap: 8px;
  align-items: center;
  padding-inline: 24px;
  padding-block: 16px;

  border-bottom: 1px solid var(--themeColorBorder);
}

.DeleteAccountModalView__content {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 0px 24px 32px;
}

.DeleteAccountModalView__confirmButton {
  margin: 8px 0 16px;
  border-color: var(--colorNegative);
  background-color: var(--colorNegative);
}
</style>
